import(/* webpackMode: "eager", webpackExports: ["GuestsClient"] */ "/vercel/path0/app/guests/guests-client.tsx");
